import { render, staticRenderFns } from "./ShowDialogSliderBienvenidos.vue?vue&type=template&id=fd46418a&scoped=true"
import script from "./ShowDialogSliderBienvenidos.vue?vue&type=script&lang=js"
export * from "./ShowDialogSliderBienvenidos.vue?vue&type=script&lang=js"
import style0 from "./ShowDialogSliderBienvenidos.vue?vue&type=style&index=0&id=fd46418a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd46418a",
  null
  
)

export default component.exports